@if (isLoading$ | async) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<nova-card class="nova-view__content in-app-notifications">
    @if (parentInAppNotificationTypeId === InAppNotificationType.Tasks) {
        <nova-card class="overdue-container">
            <div><strong>Overdue tasks</strong></div>
            <div class="flex-row items-center">
                <mat-icon [ngClass]="overdueTasksAssignedToMeCount > 0 ? 'error-icon' : 'success-icon'">
                    {{overdueTasksAssignedToMeCount > 0 ? 'warning' : 'thumb_up'}}
                </mat-icon>
                @if (isDelegatee) {
                    <span class="overdue-text" [class.none]="overdueTasksAssignedToMeCount <= 0">
                        {{overdueTasksAssignedToMeMessage}} <a class="nova__link"
                            routerLink="/travelx/tasks"
                            [queryParams]="{
                                overdue: overdueTasksAssignedToMeCount > 0,
                                assignedTo: inAppNotificationUser?.novaEmployeeId
                            }">
                                View on Tasks Grid
                            </a>
                    </span>
                } @else {
                    <span class="overdue-text" [class.none]="overdueTasksAssignedToMeCount <= 0">
                        {{overdueTasksAssignedToMeMessage}} <a class="nova__link"
                            routerLink="/travelx/tasks"
                            [queryParams]="{
                                overdue: overdueTasksAssignedToMeCount > 0,
                                mine: true
                            }">
                                View on Tasks Grid
                            </a>
                    </span>                        
                }
            </div>
            @if (hasOverdueTasksCreatedByMe && !isDelegatee) {
                <div class="flex-row items-end overdue-tasks-created-by-me">
                    <mat-icon class="material-icons-outlined">info</mat-icon>
                    <span>You have tasks created by you that are overdue.</span>
                </div>
            }
        </nova-card>
    } @else if (parentInAppNotificationTypeId === InAppNotificationType.Tickets && enableInAppNotificationsTickets) {
        <div class="ticket-notification-header"><strong>All Tickets</strong></div>
    } @else if (parentInAppNotificationTypeId === InAppNotificationType.Jobs) {
        <div class="jobs-notification-header"><strong>Action Items</strong></div>
    }
    <mat-card-header>
        <mat-card-title class="flex-row-wrap">
            <div class="flex-row items-center only-show-unread">
                <span>Only show unread</span>
                <mat-slide-toggle matTooltip="Only show unread"
                    matTooltipPosition="after"
                    [checked]="onlyShowUnread"
                    (change)="toggleOnlyShowUnread()">
                </mat-slide-toggle>
            </div>
            @if (!hasAnyUnread && inAppNotifications.length > 0) {
                <a href="#" class="nova__link mark-all-read" (click)="markAllAsRead($event)">
                    Mark all as read
                </a>
            }
        </mat-card-title>
    </mat-card-header>
    @if (inAppNotifications.length > 0) {
        <mat-card-content>
            <mat-list>
                @for (inAppNotification of inAppNotifications; track inAppNotification.id) {
                    <mat-list-item>
                        <div class="space-between items-center in-app-notification-container">
                            <div class="flex-col in-app-notification" (click)="navigateToNotificationPath(inAppNotification)">
                                <span class="help-text">
                                    {{ inAppNotification.createdDateUtc | timeAgo:true }}
                                </span>
                                <div class="in-app-notification-title">
                                    {{ inAppNotification.title }}
                                </div>
                                <div class="in-app-notification-message">
                                    {{ inAppNotification.message }}
                                </div>
                            </div>
                            <mat-slide-toggle matTooltip="Mark as {{ inAppNotification.isRead ? 'unread' : 'read' }}"
                                matTooltipPosition="after"
                                [checked]="!inAppNotification.isRead"
                                (change)="toggleRead(inAppNotification.id)">
                            </mat-slide-toggle>
                        </div>
                    </mat-list-item>
                }
            </mat-list>
        </mat-card-content>
    } @else {
        <mat-card-content class="noNotifications">
            <div class="noNotificationsHeader"><strong>No unread notifications</strong></div>
            <div><mat-icon>notifications_off</mat-icon></div>
            <div><strong>You've read all of your notifications.</strong></div>
        </mat-card-content>
    }
</nova-card>
